import { NgxsModule } from '@ngxs/store';
import { CourseState } from './course.state';
import { CourseResolver } from './course.resolver';
import { CoursesResolver } from './courses.resolver';
import { SceneResolver } from './scene.resolver';
import { DeselectSceneResolver } from './deselect-scene.resolver';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
// import { CoreFrontendSharedModule } from '@core/frontend-shared';
export let CourseStateModule = /*#__PURE__*/(() => {
  class CourseStateModule {
    static {
      this.ɵfac = function CourseStateModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CourseStateModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CourseStateModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [CoursesResolver, CourseResolver, SceneResolver, DeselectSceneResolver],
        imports: [NgxsModule.forFeature([CourseState])]
      });
    }
  }
  return CourseStateModule;
})();